
export const sFechaPublicacion = '2024-02-20T12:58:59.0941168-06:00';
export const sVersion = 'vMF0.8.02201258';
            